/** An 'error' that is raised when a coverage calculation is aborted. */
export class AbortCalculationError extends Error {
    constructor() {
        super();
        this.name = 'AbortCalculationError';
        Object.setPrototypeOf(this, AbortCalculationError.prototype);
    }
}